import { tGet } from 'src/util/objects'
import { CheckoutState } from '../../controllers/types'

export const orderAccountStatusSelector = (state: CheckoutState) =>
  tGet(state, ['order', 'account', 'status'])

export const unformattedPriceForOrderSelector = (state: CheckoutState) =>
  tGet(state, ['order', 'price_unformatted'], 0)
